"use strict";
/** @namespace */
Fotobook.fotoManager = {
    checkedElements: [],
    copyPhotoXHR: null,
    htmlOnClose: {
        ancor: '',
        span: '',
    },
    isOpenPanel: false, // нижняя панель развернута
    isDisableActions: false,
    isModified: false,
    imagesTab: {
        loaded: false,
        _images: [],
        _folders: [],
        setImages: function(images){
            this.loaded = true;
            Fotobook.fotoManager.imagesTab._images = images;
            Fotobook.fotoManager.imagesTab.sort();
        },
        setFolders: function(folders){
            this.loaded = true;
            Fotobook.fotoManager.imagesTab._folders = folders;
        },
        checkLoaded: function(){
            return $.when(this.loaded || Fotobook.core.getAlbumFotos());
        },
        sort(){
            // ---------------------------- сортировка ------------------------------------------
            var comparator = {
                sort(images, sortMethod) {
                    let f;
                    if (!sortMethod) {
                        sortMethod = Fotobook.store.getters['FotoManager/fotoSortingMethod'];
                    }
                    if (!images) {
                        images = Fotobook.fotoManager.imagesTab._images;
                    }

                    switch (sortMethod) {
                        case Fotobook.FotoSortMethod.BY_NAME_ASC:
                            f = function (a, b) {
                                return a.original_name.strnatcmp(b.original_name);
                            };
                            break;

                        case Fotobook.FotoSortMethod.BY_NAME_DESC:
                            f = function (a, b) {
                                return b.original_name.strnatcmp(a.original_name);
                            };
                            break;

                        case Fotobook.FotoSortMethod.BY_DATE_ASC:
                            f = function (a, b) {
                                return a.original_date.strnatcmp(b.original_date);
                            };
                            break;

                        case Fotobook.FotoSortMethod.BY_DATE_DESC:
                            f = function (a, b) {
                                return b.original_date.strnatcmp(a.original_date);
                            };
                            break;

                        case Fotobook.FotoSortMethod.BY_SIZE_ASC:
                            f = function (a, b) {
                                return a.size - b.size;
                            };
                            break;

                        case Fotobook.FotoSortMethod.BY_SIZE_DESC:
                            f = function (a, b) {
                                return b.size - a.size;
                            };
                            break;

                        case Fotobook.FotoSortMethod.BY_UPLOAD_ASC:
                            f = function (a, b) {
                                return a.created.strnatcmp(b.created);
                            };
                            break;

                        case Fotobook.FotoSortMethod.BY_UPLOAD_DESC:
                            f = function (a, b) {
                                return b.created.strnatcmp(a.created);
                            };
                            break;
                    }
                    images.sort(f);
                    return images;
                },
            };
            // ---------------------------- конец сортировки ------------------------------------------
            comparator.sort();
        },
        getImage: function (id, prevNext, hideUsed) {
            var image;
            for (var i = 0; i < Fotobook.fotoManager.imagesTab._images.length; i++) {
                if (Fotobook.fotoManager.imagesTab._images[i].id == id) {
                    image = Fotobook.fotoManager.imagesTab._images[i];
                    if (prevNext) {
                        switch (prevNext) {
                            case 'next':
                                var nextImage = i+1;
                                //если выбран чекбокс Скрыть, ищем следующую не скрытую фотографию
                                while (nextImage < Fotobook.fotoManager.imagesTab._images.length && Fotobook.fotoManager.imagesTab._images[nextImage].selected && hideUsed){
                                    nextImage++;
                                }
                                return Fotobook.fotoManager.imagesTab._images[nextImage];
                                break;
                            case 'prev':
                                var prevImage = i-1;
                                //если выбран чекбокс Скрыть, ищем предидущую не скрытую фотографию
                                while (prevImage >= 0 && Fotobook.fotoManager.imagesTab._images[prevImage].selected && hideUsed){
                                    prevImage--;
                                }
                                return Fotobook.fotoManager.imagesTab._images[prevImage];
                                break;
                            default:
                                return false;
                                break;
                        }
                    }
                }
            }
            return image;
        },
        updateImageAttrs: function (id, attrs) {
            var j, image;
            image = Fotobook.fotoManager.imagesTab.getImage(id);
            if (image) {
                for (j in attrs) {
                    image[j] = attrs[j];
                }
            }
        },
        removeImage: function(id){
            var image = Fotobook.fotoManager.imagesTab.getImage(id);
            Fotobook.fotoManager.imagesTab._images.splice(Fotobook.fotoManager.imagesTab._images.indexOf(image), 1);
        },
    },
    rotateImage(angle, fotoIds) {
        return Fotobook.ajax.postJSON('/photos/rotate', {
            data: {
                angle,
                fotoIds,
            },
            longQueryText: `${t('photobook-js-operationRotate')}...`,
        });
    },
    /**
     * Показать содержимое альбома ???
     * Раньше метод отправлял запрос на сервер и забирал разметку с папками;
     * сейчас это, видимо, не используется, но метод остался для вспомагательных целей.
     *
     * @param id
     * @param clearList
     */
    openFotoCollection(id, clearList) {
        if (Fotobook.fotoManager.isDisableActions) {
            return;
        }

        // $('[name=deselect-fotos]').prop('checked', false);
        Fotobook.store.dispatch('imagesPanel/setAllPhotosSelected', false);

        Fotobook.fotoManager.beforeActionsInWizard();
        Fotobook.bottomPanel.carousel.create();
        if (Fotobook.book.recalcCarouselFigures) {
            Fotobook.book.recalcCarouselFigures();
        }

        Fotobook.fotoManager.updatePhotocollectionPhotosList(id, clearList);
    },

    closeFotocollection: function(e){
        $('.photocollection-content').html('').hide();
        $('#fotos').find('a').trigger('click');
        $('.site_header .breadcrumbs').html('<a href="/">' + Fotobook.fotoManager.htmlOnClose.ancor + '</a>' +
                ' » ' +
                '<span>' + Fotobook.fotoManager.htmlOnClose.span + '</span>');
        Fotobook.fotoManager.isOpenPanel = false;
        if (e){
            e.preventDefault();
        }
    },
    beforeActionsInWizard: function(){
        Fotobook.fotoManager.readEvents();
        Fotobook.fotoManager.isOpenPanel = true;
    },
    afterActionsInWizard: function(){
        Fotobook.fotoManager.removeEvents();
        Fotobook.fotoManager.isModified = false;
        Fotobook.fotoManager.isOpenPanel = false;
    },
    readEvents: function () {
        $(document)
            .off('.fotobookFotoManagerActions')
            .on('click.fotobookFotoManagerActions', '.edit-buttons-set .button, .edit-buttons-set a', Fotobook.fotoManager.doAction)
    },
    removeEvents: function(){
        $(document).off('.fotobookFotoManagerActions');
    },

    /**
     * Найти отмеченые фото (карусель -фото, альбомы - редактирование) - видимо, актуально только для редактора
     */
    findCheckedElements() {
        Fotobook.fotoManager.checkedElements = [];

        // TODO сделать лучше, перенести состояние в vuex
        $('.photocollection-photos-list').find('.md-checkbox.md-checked').each(function () {
            const $checkboxWrapper = $(this).parents('.check-folder-or-foto');

            // не учитываем папки
            if ($checkboxWrapper.hasClass('check-folder')) {
                return;
            }
            const $img = $(this).closest('li').find('img.image');
            Fotobook.fotoManager.checkedElements.push($img);
        });
    },

    /**
     * Выполнить действие по нажатию кнопки управления фото/папкой в менеджере
     * TODO перенести в vue компонент и разбить на отдельные методы
     */
    doAction: function(){
        var self = $(this),
            action = self.attr("data-action"),
            id = self.attr("data-id");

        // button disabled
        if (self.hasClass('disabled')){
            return false;
        }

        if (Fotobook.fotoManager.isDisableActions) {
            return false;
        }
        Fotobook.fotoManager.findCheckedElements();
        // if (action != 'deselect-photos' && action != undefined && !self.hasClass("skip-elements") && !Fotobook.fotoManager.checkedElements.length) {
        if (action !== undefined && !self.hasClass('skip-elements') && !Fotobook.fotoManager.checkedElements.length) {
            Fotobook.notification.showWarning(t('photobook-js-selectFotos'));
        }
        Fotobook.fotoManager.isModified = true;
        switch (action) {
            case 'rotate-left':
                Fotobook.fotoManager.actionRotate(-90);
                break;
            case 'rotate-right':
                Fotobook.fotoManager.actionRotate(90);
                break;
            case 'copy-to-gallery':
                Fotobook.fotoManager.actionCopyToGallery();
                break;
            case 'delete-photos':
                Fotobook.fotoManager.actionDelete();
                break;
            case 'add-photo':
                Fotobook.import.showImportDialog({"album_id" : id});
                break;
                // moved to vue component
            // case 'deselect-photos':
            //     Fotobook.fotoManager.toggleAllElementsSelection();
            //     break;
            case 'create-folder':
                Fotobook.fotoManager.actionCreateFolder();
                break;
            case 'move-fotos':
                Fotobook.fotoManager.actionMoveFotos();
                break;
            default:
                break;
        }
    },
    getCheckedElementsIds: function (withOriginal) {
        var params = {
                elements: []
            };
        for (var i = 0; i < this.checkedElements.length; i++) {
            if (!withOriginal || !this.checkedElements[i].closest('.photocollection-photo-image').hasClass('no-original')){
                params.elements.push(Number(this.checkedElements[i].attr('data-id')));
            }
        }
        return params;
    },

    /**
     * Выполнить копирование фото
     * @param albumId int ID альбома для копирования
     */
    fileCopyProgress: function (albumId) {
        var self = this,
            params = self.getCheckedElementsIds(true);

        self.copyPhotoXHR = Fotobook.ajax.postJSON("/photos/process-copy-photos", {
            "data":{
                "data": {
                    "photo_ids": params.elements,
                    "album_id": albumId,
                },
                "queue": false,
            },
        });

        self.copyPhotoXHR.then((request) => {
            var data = request.data;
            $("#loader").hide();
            if (data.status === 0) {
                $("#success").show();
            } else {
                $("#fail").show().find("#copied-total").text(data.copied);
            }
            $("#copy-photos-dialog").dialog('option', 'buttons', [{
                'text': t('photobook-js-buttonsOk'),
                'click': function(){
                    $(this).dialog('close');
                }
            }]);
        }).catch(() => {});
    },

    /**
     * Создать папку
     */
    actionCreateFolder(data) {
        const panel = $('.images-carousel-wrapper');
        const albumId = panel.attr('data-currentAlbumId');
        const options = {};

        if (data) {
            $.extend(options, {
                data,
                longQueryTimeout: 200,
                longQueryText: t('photobook-js-creatingFolder'),
            });
        }

        Fotobook.ajax.postJSON('/photos/create-folder', options).then((response) => {
            if (response.data.success) {
                Fotobook.fotoManager.updatePhotocollectionPhotosList(albumId);
                Fotobook.core.updateAlbumsList();
                return;
            }
            Fotobook.dialog.confirm('<div id="create-folder-dialog">' + response.data.html + '</div>', {
                title: t('photobook-js-dialog-createFolderTitle'),
                width: '390px',
                buttonResolve: t('photobook-js-buttonsSave'),
                buttonReject: t('photobook-js-buttonsCancel'),
                resolveOnEnter: true,

            })
                .then(() => {
                    Fotobook.fotoManager.actionCreateFolder({
                        albumId,
                        name: $.trim($('#folderName').val()),
                    });
                })
                .catch(() => {});
        }).catch(() => {
        });
    },

    /**
     *  Переместить фото в другую фотоколлекцию
     */
    moveFotoResponseToText: function(response, albumId){
        var albums = [];

        Fotobook.book.createAlbumTree(albums, response.data.albums);
        return response.data.html.supplant({
            "album-select-options" : Fotobook.book.createAlbumOptionsList(albums, [], [albumId]).join(""),
        });

    },
    actionMoveFotos: function(data){
        var panel = $('.images-carousel-wrapper'),
            albumId = parseInt(panel.attr('data-currentAlbumId'), 10),
            params = Fotobook.fotoManager.getCheckedElementsIds(true),
            self = this;

        if (params.elements.length < 1){
            return;
        }
        const options = {
            data: {
                ...data,
            },
        };
        if (data) {
            $.extend(options, {
                longQueryTimeout: 200,
                longQueryText: t('photobook-js-movingFotos'),
            });
        }

        Fotobook.ajax.postJSON('/photos/import/move-fotos', options).then((response) => {
            if (response.data.success) {
                if (response.data.deleted_from_project){
                    Fotobook.ajax.post('/photos/import/update-after-upload').then((response) => {
                        if (response.data) {
                            Fotobook.book.initState(response.data);
                        }
                    });
                }
                Fotobook.fotoManager.updatePhotocollectionPhotosList(albumId);
                Fotobook.fotoManager.getTotalCountFotos();
            }

            let customOptions;
            if (response.data.success || response.data.error){
                customOptions = {
                    "buttonReject": t("photobook-js-buttonsOk"),
                    "showButtonResolve" : false,
                };
            } else {
                customOptions = {
                    "buttonResolve": t("photobook-js-buttonsMove"),
                    "buttonReject": t("photobook-js-buttonsCancel"),
                }
            }

            const $dialog = Fotobook.dialog.confirm('<div id="move-fotos-dialog">'+self.moveFotoResponseToText(response, albumId)+'</div>', $.extend({
                "title": t("photobook-js-dialog-moveFotosTitle"),
                "width": "390px",
                "open": function(){
                    var $this = $(this);
                    // todo сделать менее костыльным способом
                    if ($this.find('#album_field').find('option').length < 2){
                        $this.closest('.ui-dialog').find(".fotobook-dialogbutton-resolve").remove();
                    }
                },
            }, customOptions));

            $dialog.then(() => {
                self.actionMoveFotos({
                    fotos: params.elements,
                    toAlbumId: $dialog.find('#album_field').val(),
                });
            }).catch(() => {});
        }).catch(() => {});
    },

    /** Порвернуть фото */
    actionRotate(angle) {
        const self = this;

        const fotoIds = self.checkedElements.reduce((ids, $img) => {
            if (!$img.closest('.no-original').length) {
                ids.push(Number($img.attr('data-id')));
            }
            return ids;
        }, []);
        if (!fotoIds.length) {
            return;
        }

        self.isDisableActions = true;
        const $layer = Fotobook.onlineEditorActive() ? $('#bottom-tabs').find('.item') : $('.photocollection-content');
        $layer.css('opacity', '0.5');
        Fotobook.fotoManager.rotateImage(angle, fotoIds).then((response) => {
            self.applyChange(response.data.fotos);
            if (Fotobook.onlineEditorActive()) {
                Fotobook.book.updateBookFromResponse(response.data);
            }
        }).catch(() => {})
        .finally(() => {
            $layer.css('opacity', '');
            self.isDisableActions = false;
        });
    },

    /**
     * Подгрузить кнопки управления копирования фото
     */
    getCopyButtons: function (params) {
        var buttons = [],
            self = this;
        if ($('#album_field').find('option').length > 1) {
            buttons.push({
                'id': 'selectAlbum',
                'text': t('photobook-js-buttonsCopy'),
                'click': function(){
                    $('#select-collection').hide();
                    $("#loader").show();
                    $("#loader #total").html(params.elements.length);
                    $('#copy-photos-dialog').dialog("option", "buttons", [
                        {
                            text: t('photobook-js-buttonsCancel'),
                            class: 'fotobook_button neutral-button',
                            click: function(){
                                self.copyPhotoXHR.abort();
                                $('#copy-photos-dialog').dialog('close');
                            }
                        }
                    ]);
                    self.fileCopyProgress($("#album_field option:selected").val());
                    self.getTotalCountFotos();
                }
            });
        }
        buttons.push({
            'text': t('photobook-js-buttonsCancel'),
            'click': function(){
                $(this).dialog("close")
            }
        });
        return buttons;
    },

    /**
     * Копировать в другую коллекцию
     */
    actionCopyToGallery: function(){
        var self = this,
            params = self.getCheckedElementsIds(true),
            panel = $('.images-carousel-wrapper'),
            albumId = parseInt(panel.attr('data-currentAlbumId'), 10);
        if (params.elements.length > 0) {
            Fotobook.ajax.postJSON("/photos/import/copy-dialog", {
                "data" : {
                    "album_id": albumId,
                },
            }).then((response) => {
                $('<div id="copy-photos-dialog">'+self.moveFotoResponseToText(response, albumId)+'</div>').dialog({
                    'title': t('photobook-js-copyDialogTitle'),
                    'width': 350,
                    'modal': true,
                    'autoResize': true,
                    'resizable': false,
                    'closeOnEscape': true,
                    'dialogClass': 'fotobook-dialog editor copy-photos-dialog upper-dialog',
                    'close': function(){
                        $(this).dialog('destroy');
                    },
                    'open': function(){
                        var $this = $(this);
                        $this.dialog('option', 'buttons', self.getCopyButtons(params));
                        $('#loader').hide();
                        $('.ui-widget-overlay:first').addClass('upper-overlay');
                    }
                });
            });
        }
    },
    checkClipartUsage(elements){
        return Fotobook.ajax.postJSON("/photos/get-clipart-usage", {
            "data" : {
                "data" : elements,
            },
        }).then((response) => {
            const used = response.data.current + response.data.others,
                  text = used ? t("photobook-js-removeUsedPhotosQuestion") : t("photobook-js-removePhotosQuestion", {"count" : elements.Albums.length + elements[Fotobook.ClipartType.FOTO].length});

            return Fotobook.dialog.confirm(text, {
                "title": t("photobook-js-removePhotoDialogTitle"),
                "fotobookDialogClass": 'autotest-confirm-delete-fotos',
            });
        });
    },
    actionDelete: function(){
        var self = this,
            elements = {
                "Albums" : [],
            };

        elements[Fotobook.ClipartType.FOTO] = [];

        // TODO сделать лучше, перенести состояние в vuex
        $('.photocollection-photos-list').find('.md-checkbox.md-checked').each(function () {
            const $checkboxWrapper = $(this).parents('.check-folder-or-foto');
            const $imageWrapper = $checkboxWrapper.parents('.photocollection-photo-image-wrapper');
            const id = $imageWrapper.attr('data-id');
            if (!id) {
                console.error('[action:delete] No item id provided!');
            }

            if ($checkboxWrapper.hasClass('check-foto')) {
                elements[Fotobook.ClipartType.FOTO].push(id);
            } else if ($checkboxWrapper.hasClass('check-folder')) {
                elements.Albums.push(id);
            }
        });

        if (!elements[Fotobook.ClipartType.FOTO].length && !elements.Albums.length){
            Fotobook.notification.showWarning(t('photobook-js-selectFotos'));
            return;
        }

        if (!Fotobook.isCurrentAlbum()){
            Fotobook.dialog.alert(t("photobook-js-fotosDeletingNotInProject"));
            return false;
        }
        this.checkClipartUsage(elements).then(() => {
            self.isDisableActions = true;
            Fotobook.import.deleteClipart(elements).then((response) => {
                if (response.data.not_deleted){
                    Fotobook.dialog.alert(t("photobook-js-someElementsWereNotDeleted"));
                }
                self.afterDel(response.data.deleted);
            }).catch(
                () => {},
            ).finally(() => {
                self.isDisableActions = false;
            });
        }).catch(
            () => {}
        );
    },
    afterDel(deleted) {
        if (deleted[Fotobook.ClipartType.FOTO] && deleted[Fotobook.ClipartType.FOTO].length) {
            for (let i = 0; i < deleted[Fotobook.ClipartType.FOTO].length; i++) {
                Fotobook.fotoManager.imagesTab.removeImage(deleted[Fotobook.ClipartType.FOTO][i]);

                // переделано на vue, больше не актуально
                // $(".photocollection-photo-image")
                //     .find(".image[data-id=" + deleted[Fotobook.ClipartType.FOTO][i] + "]")
                //     .closest('li').remove();
            }
        }
        Fotobook.fotoManager.updatePhotocollectionPhotosList();
        if (Fotobook.onlineEditorActive()) {
            Fotobook.core.updateAlbumsList();
        }
    },
    applyChange: function(list){
        for (var i = 0; i < list.length; i++) {
            var $img = $(".photocollection-photos-list [data-id=" + list[i].id + "]"),
                new_src = Fotobook.createStorageUrl(list[i].preview_path + "?version=" + list[i].version);
            $img.attr({"src": new_src, "rel": list[i].path});
            Fotobook.fotoManager.imagesTab.updateImageAttrs(list[i].id, $.extend({}, list[i], {
                "foto_path": new_src,
            }));
        }
    },

    /** отрисовка контента развернутой нижней панели с фото */
    renderFotoCollection: function () {
        Fotobook.store.dispatch('imagesPanel/draw');
    },

    updatePhotocollectionPhotosList: function (id, clearList) {
        this.checkFotocollectionList(id, clearList).then(
            () => this.renderFotoCollection(),
            () => {}
        );
    },
    checkFotocollectionList: function(id, clearList){
        const $panel = $('.images-carousel-wrapper');
        if (!id) {
            id = $panel.attr('data-currentAlbumId');
        }
        if (clearList) {
            return Promise.resolve();
        }

        return Fotobook.ajax.postJSON("/photos/get-album-photos", {
            "data": {
                "id": id,
            },
        }).then((response) => {
            response = response.data;
            Fotobook.fotoManager.imagesTab.setImages(response.fotos);
            Fotobook.fotoManager.imagesTab.setFolders(response.folders);
            $panel.attr('data-currentAlbumId', id);

            // вынесено в vue компонент
            // setTimeout(() => Fotobook.fotoManager.makeFoldersDroppable());
        });
    },

    /**
     *  Подсчитать общее кол-во фотографий и в альбоме (прокекте)
     */
    getTotalCountFotos(projectId) {
        // TODO не понял, к чему отправлять запрос на сервер, результат которого мы вообще не используем
        // закомментил большую часть кода из этих соображений, нужно пересмотреть или удалить его
        // projectId = projectId || $('.photocollection-content .item').data('projectid');
        // if (undefined === projectId) {
        //     return false;
        // }
        //
        // Fotobook.$http.post('/base/get-total-fotos-count', {
        //     data: {
        //         projectId,
        //     },
        // }).then(() => {
        //     // кол-во фото посчитать только для текущей папки, не для всего проекта
        //     // todo - что-то из функционала потерялось
        //     var photosInFolder = $('.photocollection-photos-list .photocollection-photo-image.selectable').length;
        //     Fotobook.fotoManager.setButtonsState(photosInFolder);
        // });
        // TODO не учитываются папки, надо доделать
        const photosInFolder = $('.photocollection-photos-list .photocollection-photo-image.selectable').length;
        Fotobook.fotoManager.setButtonsState(photosInFolder);
    },

    /**
     * Изменить состояние кнопок управления фото после оперций
     */
    setButtonsState(elementsCount) {
        if (parseInt(elementsCount) === 0) {
            // снять галку с чекбокса если нет элементов
            // $('[name=deselect-fotos]').prop('checked', false);
            Fotobook.store.dispatch('imagesPanel/setAllPhotosSelected', false);
        }
    },
};

$(document)
    .on("click", "#photocollection-close", Fotobook.fotoManager.closeFotocollection)
    .on("clipart-uploaded", function (event, data) {
        if (data.clipart_class === Fotobook.ClipartType.FOTO && (!Fotobook.onlineEditorActive() || Fotobook.fotoManager.isOpenPanel)) {
            Fotobook.fotoManager.updatePhotocollectionPhotosList(data.album_id)
        }
    });

Fotobook.Vue.observable(Fotobook.fotoManager.imagesTab);
